// ✅ Nouveau CourseContent.js avec boutons Suivant/Précédent et bouton Compris
import React from "react";
import { Card, Row, Col, Steps, Button, Space } from "antd";

const { Step } = Steps;

const CourseContent = ({
  subjects,
  selectedSubjectId,
  onSelectSubject,
  onMarkCompleted,
  completedSubjects
}) => {

  const selectedSubject = subjects.find((s) => s.id === selectedSubjectId);
  const currentIndex = subjects.findIndex((s) => s.id === selectedSubjectId);

  const goToNext = () => {
    if (currentIndex < subjects.length - 1) {
      onSelectSubject(subjects[currentIndex + 1]);
    }
  };

  const goToPrevious = () => {
    if (currentIndex > 0) {
      onSelectSubject(subjects[currentIndex - 1]);
    }
  };

  return (
    <Row gutter={24}>
      {/* Colonne gauche : Sommaire */}
      <Col span={6}>
        <Card title="Sommaire">
          <Steps
            direction="vertical"
            size="small"
            current={currentIndex}
            onChange={(current) => onSelectSubject(subjects[current])}
          >
            {subjects.map((subject) => (
<Step
  key={subject.id}
  title={
    <span>
      {completedSubjects[subject.id] ? "✅ " : ""}
      {subject.title}
    </span>
  }
/>

))}
          </Steps>
        </Card>
      </Col>

      {/* Colonne droite : Contenu + actions */}
      <Col span={18}>
        <Card title={selectedSubject?.title || "Contenu du cours"}>
          <div
            style={{ marginBottom: 20 }}
            dangerouslySetInnerHTML={{
              __html: selectedSubject?.content || "Aucun contenu.",
            }}
          />

          <Space style={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={goToPrevious} disabled={currentIndex === 0}>
              ← Précédent
            </Button>

            <Button
              type="primary"
              onClick={() => onMarkCompleted(selectedSubjectId)}
              style={{ backgroundColor: "#faad14", borderColor: "#faad14" }}
            >
              🤔 Compris ?
            </Button>

            <Button
              onClick={goToNext}
              disabled={currentIndex === subjects.length - 1}
              type="primary"
            >
              Suivant →
            </Button>
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

export default CourseContent;
